var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconeMunicipio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1229",
    "data-name": "Grupo 1229",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 153.894,
    height: 118.366,
    viewBox: "0 0 153.894 118.366",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_745",
    "data-name": "Ret\\xE2ngulo 745",
    width: 153.894,
    height: 118.366,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1228",
    "data-name": "Grupo 1228",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2419",
    "data-name": "Caminho 2419",
    d: "M153.894,91.473v22.816c-.519,2.984-2.852,4.079-5.208,4.077q-71.662-.057-143.324-.031c-3.5,0-5.324-1.855-5.327-5.4q-.007-9.98,0-19.959c0-3.905,1.735-5.7,5.607-5.828,1.75-.056,1.918-.188,1.919-1.887q.018-25.137,0-50.273c0-.327.124-.7-.312-1.048-.722.458-1.373,1.068-2.082,1.6C3.3,36.927,1.622,36.88.533,35.415A3.409,3.409,0,0,1,1.545,30.8Q14.653,20.4,27.684,9.9q5.445-4.363,10.91-8.7c2.034-1.622,3.211-1.606,5.337.092q9.148,7.3,18.284,14.62c1.979,1.581,1.953,1.552,3.855,0,2.9-2.374,5.7-4.878,8.636-7.213,1.8-1.43,2.876-1.42,4.683.016,3.054,2.429,5.969,5.023,8.98,7.5,1.411,1.163,1.623,1.19,3.077.029q9.088-7.258,18.165-14.529c2.863-2.292,3.755-2.28,6.665.047q17.638,14.106,35.274,28.214c1.009.806,2.129,1.524,2.344,2.958v1.5c-.887,2.22-2.465,2.74-4.494,1.487a28.2,28.2,0,0,0-2.539-1.816c-.5.5-.31,1.078-.31,1.6q-.015,24.514-.007,49.028c0,2.27.037,2.3,2.189,2.391,3.046.131,4.414,1.284,5.161,4.35",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2420",
    "data-name": "Caminho 2420",
    d: "M168.714,78.387a5.6,5.6,0,0,0-5.526-3.094c-6.352.076-12.7.018-19.057.028-3.853.006-5.79,1.961-5.791,5.83,0,12.9-.021,25.809.03,38.713.005,1.256-.309,1.55-1.552,1.544q-16.431-.08-32.863-.005c-1.15,0-1.5-.26-1.5-1.466q.062-26.709.01-53.418a2.383,2.383,0,0,1,.951-2.031q17.062-14.322,34.079-28.7c.567-.479.909-.677,1.6-.095q14.825,12.554,29.7,25.046a1.179,1.179,0,0,1,.17.239,3.79,3.79,0,0,1,.482,2.157c0,4.391.017,8.783-.018,13.174-.006.739.241,1.634-.715,2.074",
    transform: "translate(-61.302 -21.143)",
    fill: "#0069d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2421",
    "data-name": "Caminho 2421",
    d: "M13.2,234.2c-.156-3.665-.156-3.665,3.44-3.665,8.553,0,17.105.025,25.657-.027,1.246-.008,1.667.329,1.587,1.587-.1,1.644-.062,3.3-.012,4.949.027.863-.3,1.139-1.136,1.106-1.248-.049-2.5-.049-3.75,0a2.614,2.614,0,0,0-2.728,2.594,2.451,2.451,0,0,0,2.745,2.5c3.1.03,6.2.01,9.3.01h81.024c.5,0,1,.013,1.5,0,1.649-.058,2.654-.947,2.714-2.387a2.58,2.58,0,0,0-2.616-2.7,30.721,30.721,0,0,0-3.749-.008c-1.015.059-1.286-.347-1.25-1.3.063-1.7.053-3.4,0-5.1-.026-.874.21-1.241,1.166-1.235,8.151.049,16.3.055,24.453.074a2.533,2.533,0,0,1,.484,1.839q.024,8.174,0,16.348c-.01,1.972-.146,2.07-2.165,2.07H15.028c-1.718,0-1.72,0-1.72-1.666q0-6.749,0-13.5a3.955,3.955,0,0,0-.1-1.485",
    transform: "translate(-7.87 -137.919)",
    fill: "#0069d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2422",
    "data-name": "Caminho 2422",
    d: "M79.556,30.933c-2.773,2.344-5.475,4.634-8.183,6.916-4.855,4.09-9.722,8.167-14.563,12.275a2.852,2.852,0,0,1-2.011.75c-3.9-.037-7.8-.024-11.7-.014-3.547.009-5.592,2.028-5.6,5.571-.011,12.951-.025,25.9.026,38.851.005,1.359-.322,1.79-1.724,1.751-3.427-.1-3.429-.024-3.429-3.451q0-26.851-.024-53.7a2.971,2.971,0,0,1,1.228-2.641c8.654-6.864,17.264-13.783,25.9-20.674.487-.388.868-1.051,1.735-.349,6.055,4.908,12.154,9.762,18.344,14.717",
    transform: "translate(-19.357 -9.517)",
    fill: "#5cd2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2423",
    "data-name": "Caminho 2423",
    d: "M233.55,31.068c6.235-4.989,12.293-9.816,18.317-14.685.662-.535,1.046-.407,1.628.06q13.21,10.613,26.464,21.169a2.262,2.262,0,0,1,.84,2.066q-.017,26.249-.009,52.5c0,1.25-.034,2.5.012,3.75.029.793-.163,1.134-1.063,1.167-4.072.153-4.071.184-4.071-3.862q0-18.15,0-36.3c0-4.135-1.893-6-6.072-6-3.75,0-7.5-.008-11.251.007a2.483,2.483,0,0,1-1.775-.568q-11.16-9.447-22.366-18.84c-.153-.129-.326-.233-.654-.464",
    transform: "translate(-139.737 -9.593)",
    fill: "#6eacde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2424",
    "data-name": "Caminho 2424",
    d: "M219.795,188.5c-4.744.014-9.489.01-14.233.059-.88.009-1.083-.329-1.082-1.142q.03-19.328,0-38.656c0-.812.2-1.151,1.082-1.142,4.744.048,9.489.045,14.232.059a2.711,2.711,0,0,1,.484,1.982c.011,5.98,0,11.96.01,17.941a17.105,17.105,0,0,1-.462,2.632q0,.408,0,.816c.695,2.183.429,4.433.451,6.66.029,2.887.016,5.774,0,8.661a2.944,2.944,0,0,1-.484,2.129",
    transform: "translate(-122.344 -88.323)",
    fill: "#0069d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2425",
    "data-name": "Caminho 2425",
    d: "M267.407,116.583c.42-.472.24-1.046.241-1.575q.02-7.915.009-15.83c1.537,1.269,3.047,2.574,4.625,3.791.694.535.6,1.2.6,1.885q0,22.2,0,44.4c0,3.05-.031,6.1.019,9.149.014.9-.219,1.184-1.161,1.2-3.995.057-3.994.091-3.994-3.91q0-18,0-36a10.083,10.083,0,0,0-.342-3.108",
    transform: "translate(-159.994 -59.34)",
    fill: "#0069d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2426",
    "data-name": "Caminho 2426",
    d: "M57.947,156.395c-.021-3.647-.058-7.293-.061-10.94-.009-9.446.022-18.892-.033-28.337-.008-1.276.369-1.628,1.6-1.553,1.692.1,3.4.026,5.531.026-1.336,1.177-2.425,2.121-3.5,3.085a2.529,2.529,0,0,0,2.549,4.341,11.536,11.536,0,0,0,1.379-.887A2.515,2.515,0,0,1,65.9,124.1q.021,15.116,0,30.231c0,2.151-.11,2.261-2.3,2.21a32.907,32.907,0,0,1-5.651-.149",
    transform: "translate(-34.614 -69.139)",
    fill: "#5cd2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2427",
    "data-name": "Caminho 2427",
    d: "M294.058,159.564c-.027-2-.074-3.995-.076-5.992q-.011-15.374,0-30.748v-2c1.949,1.635,3.56,3.013,5.2,4.355.712.581,1.315,1.391,2.387,1.351a2.51,2.51,0,0,1,.479,1.974q.022,14.509,0,29.018c0,2.1-.121,2.216-2.184,2.175a39.956,39.956,0,0,1-5.805-.135",
    transform: "translate(-175.892 -72.293)",
    fill: "#78b4d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2428",
    "data-name": "Caminho 2428",
    d: "M294.178,156.436q2.693,0,5.387-.01c2.121,0,2.122,0,2.122-2.051q0-15.485,0-30.971c3.176-.69,3.259-3.662,1.061-5.132a12.925,12.925,0,0,1-1.34-1.181,1.5,1.5,0,0,1,.263-1.435c1.347-.014,2.7.009,4.041-.055.858-.041,1.126.291,1.11,1.126-.043,2.2-.014,4.392-.014,6.589,0,10.583-.025,21.166.031,31.749.007,1.339-.365,1.693-1.677,1.657-3.192-.088-6.389-.006-9.584-.017-.472,0-1.009.2-1.4-.269",
    transform: "translate(-176.012 -69.164)",
    fill: "#78b4d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2429",
    "data-name": "Caminho 2429",
    d: "M58.087,160.157c2,0,3.995-.063,5.986.031,1.193.056,1.519-.335,1.514-1.516-.045-10.927-.032-21.854-.036-32.78q2.138-1.865,4.276-3.729c.524-.456.887-.494.885.358,0,.25,0,.5,0,.75,0,11.841-.022,23.682.031,35.522.006,1.336-.369,1.7-1.683,1.665-3.2-.086-6.395,0-9.592-.018-.464,0-1.011.229-1.384-.283",
    transform: "translate(-34.755 -72.902)",
    fill: "#5cd2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2430",
    "data-name": "Caminho 2430",
    d: "M13.121,234.239c.419.475.239,1.052.241,1.583.014,4.4.063,8.8-.024,13.2-.028,1.389.379,1.751,1.756,1.749q45.166-.058,90.332-.03c14.755,0,29.511-.021,44.266.033,1.46.005,1.834-.412,1.816-1.841-.078-6.1-.033-12.2-.033-18.305,1.349-.016,2.7-.008,4.048-.059.755-.029,1.064.215,1.06,1.017q-.036,9.226,0,18.452c0,.817-.319,1.018-1.065,1-1.8-.032-3.6,0-5.4,0q-67.587,0-135.174.031c-1.444,0-1.969-.247-1.925-1.845.139-5,.082-10,.1-15",
    transform: "translate(-7.789 -137.954)",
    fill: "#0069d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2431",
    "data-name": "Caminho 2431",
    d: "M242.639,170.253q-.016-11.277-.033-22.554c1.348-.01,2.7.014,4.045-.044.861-.038,1.113.31,1.11,1.137-.024,6.044-.045,12.088.013,18.132.012,1.248-.646,1.269-1.5,1.18a3.08,3.08,0,0,0-3.634,2.149",
    transform: "translate(-145.156 -88.342)",
    fill: "#0069d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2432",
    "data-name": "Caminho 2432",
    d: "M242.607,223.4q.015-8.725.031-17.45a3.025,3.025,0,0,0,3.625,2.142c1.183-.155,1.532.3,1.512,1.485-.069,4.193-.051,8.388-.009,12.581.01.965-.268,1.349-1.267,1.289-1.293-.078-2.594-.037-3.892-.048",
    transform: "translate(-145.156 -123.224)",
    fill: "#0069d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2433",
    "data-name": "Caminho 2433",
    d: "M310.213,115.744c-.047.486.21,1.027-.264,1.435a4.694,4.694,0,0,1-1.5-1.435Z",
    transform: "translate(-184.552 -69.252)",
    fill: "#964d2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2434",
    "data-name": "Caminho 2434",
    d: "M128.142,134.856c2.5,0,5-.033,7.505.009a5.022,5.022,0,0,1,5.219,5.2q.06,7.579,0,15.159a5.064,5.064,0,0,1-5.228,5.213q-7.58.052-15.161,0a4.962,4.962,0,0,1-5.178-5.072q-.095-7.729,0-15.46a4.913,4.913,0,0,1,5.188-5.039c2.551-.041,5.1-.008,7.655-.008",
    transform: "translate(-68.957 -80.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2435",
    "data-name": "Caminho 2435",
    d: "M138.017,162.931c-2.942.01-5.885-.018-8.825.052-.948.022-1.168-.295-1.16-1.189.041-4.338.019-8.677.018-13.016,0-.593-.127-1.2.846-1.181,3.139.064,6.279.068,9.419.095a2.2,2.2,0,0,1,.485,1.671c.018,3.924.028,7.847-.007,11.771-.006.689,0,1.423-.775,1.8",
    transform: "translate(-76.604 -88.309)",
    fill: "#0069d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2436",
    "data-name": "Caminho 2436",
    d: "M152.891,162.949a2.733,2.733,0,0,0,.291-1.74q.007-6.75.006-13.5c1.348-.024,2.7-.024,4.046-.08.745-.031,1.073.189,1.067,1q-.045,6.677,0,13.356c.006.818-.314,1.028-1.062,1-1.448-.049-2.9-.032-4.349-.042",
    transform: "translate(-91.478 -88.327)",
    fill: "#0069d0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeMunicipio);
export default __webpack_public_path__ + "static/media/Icone_Municipio.d0d2604255df3cb531459bf97a11c4c4.svg";
export { ForwardRef as ReactComponent };